const DESIGN_ELEMENT_LOCAL = {
    "zh-CHS": {
        codeEditor: {
            switchTo: '切换到',
            unexist: '当前文件"{param}"在系统中未创建',
            nohook: '未注入"{command}"钩子，不能执行{command2}',
            noeditor: '当前编辑器实例不存在',
            unsave: '当前编辑器内容未保存，不能覆盖内容',
            addFailed: '添加方法失败，找不到对应的类代码',
            showFailed: '当前文件不存在，无法渲染',
            modifyNosave: '当前文件已修改尚未保存',
            noshow: '当前文件未渲染，无法进行格式化',
            noshow2: '当前编辑器没有渲染，无法定位到具体位置',
            note: '参数缺少注释',
            note2: '方法缺少注释',
        }


    },
    "zh-CHT": {
        codeEditor: {
            switchTo: '切換到',
            unexist: '當前文件"{param}"在系統中未創建',
            nohook: '未注入"{command}"鈎子，不能執行{command2}',
            noeditor: '當前編輯器實例不存在',
            unsave: '當前編輯器內容未保存，不能覆蓋內容',
            addFailed: '添加方法失敗，找不到對應的類代碼',
            showFailed: '當前文件不存在，無法渲染',
            modifyNosave: '當前文件已修改尚未保存',
            noshow: '當前文件未渲染，無法進行格式化',
            noshow2: '當前編輯器沒有渲染，無法定位到具體位置',
            note: '參數缺少注釋',
            note2: '方法缺少注釋',
        }
       
    },
    "en": {
        codeEditor: {
            switchTo: 'Switch to',
            unexist: "The current file '{param}' has not been created in the system",
            nohook: "Unable to execute {command2} without injecting the '{command}' hook",
            noeditor: 'The current editor instance does not exist',
            unsave: 'The current editor content has not been saved and cannot be overwritten',
            addFailed: 'Adding method failed, unable to find corresponding class code',
            showFailed: 'The current file does not exist and cannot be rendered',
            modifyNosave: 'The current file has been modified but not saved yet',
            noshow: 'The current file has not been rendered and cannot be formatted',
            noshow2: 'The current editor does not render and cannot locate the specific location',
            note: 'Missing comment for parameter',
            note2: 'Missing comment for method',
        }
        
    }
}
export class DesignElementLocaleHandler {
    static getValue(key: string) {

        let languageCode = 'zh-CHS';
        if (window && window.top && window.top.localStorage && window.top.localStorage.languageCode) {
            languageCode = window.top.localStorage.languageCode;
        }

        return DESIGN_ELEMENT_LOCAL[languageCode][key] || '';
    }
}